import React from 'react';
import { Clapperboard } from 'lucide-react';
import Reveal from './Reveal';
import YouTubeLite from './YouTubeLite';
import TrustpilotShowcase from './TrustpilotShowcase';
import { VIDEO_TESTIMONIALS } from '../mock';

function VideoCard({ item }) {
  const isLive = Boolean(item.videoId);
  return (
    <figure className="flex h-full flex-col overflow-hidden rounded-3xl border border-[var(--ob-line)] bg-white">
      <div className="relative aspect-video w-full bg-[var(--ob-dark)]">
        {isLive ? (
          <YouTubeLite videoId={item.videoId} title={`OnBrand ${item.label}`} size="md" />
        ) : (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-white/45">
            <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white/15">
              <Clapperboard size={26} />
            </span>
            <span className="text-xs font-semibold uppercase tracking-[0.16em]">Coming soon</span>
          </div>
        )}
      </div>
      <figcaption className="flex items-center gap-3 px-6 py-5">
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--ob-accent)]/15 text-[var(--ob-accent-dark)]">
          <Clapperboard size={16} />
        </span>
        <div>
          <div className="font-display text-sm font-bold uppercase tracking-wide text-[var(--ob-ink)]">
            {item.label}
          </div>
          <div className="text-sm text-[var(--ob-ink-soft)]">{item.caption}</div>
        </div>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-[var(--ob-bg)] py-24 md:py-32">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            Social Proof
          </p>
          <h2 className="font-display text-4xl font-extrabold leading-[1.18] tracking-tight text-[var(--ob-ink)] md:text-6xl">
            Don’t just take our word for it.
          </h2>
          <p className="mt-5 text-lg text-[var(--ob-ink-soft)]">
            See what 8- to 9-figure founders say about handing their email channel to OnBrand.
          </p>
        </Reveal>

        {/* Video testimonials (ready for at least two) */}
        <div id="testimonials" className="grid grid-cols-1 gap-6 md:grid-cols-2 scroll-mt-24">
          {VIDEO_TESTIMONIALS.map((item, i) => (
            <Reveal key={i} delay={i * 100}>
              <VideoCard item={item} />
            </Reveal>
          ))}
        </div>

        {/* Written testimonials replaced with the custom Trustpilot review showcase */}
        <Reveal>
          <TrustpilotShowcase />
        </Reveal>
      </div>
    </section>
  );
}
